import { render, staticRenderFns } from "./HomeNewsletter.vue?vue&type=template&id=135bd9d8"
import script from "./HomeNewsletter.vue?vue&type=script&lang=js"
export * from "./HomeNewsletter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports